import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";

import { CrossIcon,  LogOutIcon } from "../../assets/Icon/ModalIcon";
import { useState } from "react";
import { useAppDispatch } from "../../stores/store";
import { setToast } from "../../stores/toast/toastslice";
import { deleteAgents, getAgentList } from "../../stores/agents";
import {
  ButtonWrapper,
  CloseButton,
  CloseButtonWrapper,
  Content,
  Header,
  ModalWrapper,
} from "../../components/style/modalStyleLarge";
import { Divider, Box, useTheme, useMediaQuery } from "@mui/material";
import CustomButton from "../../components/common-components/CustomButton";
import { deleteClient, getClientList } from "../../stores/clients";
import { logOut } from "../../stores/auth";
import { useNavigate } from "react-router";

interface ModalPropType {
  open: boolean;
  handleClose: () => void;
 
 
}

export default function LogOutModal({
  open,
  handleClose,
  
 
}: ModalPropType) {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleSubmit = async () => {
    setLoading(true);

    try {
         const response = await dispatch<any>(
           logOut(localStorage.getItem("user_token"))
         );
   
         if (response?.payload?.status === 1) {
           localStorage.clear();
           setLoading(false);
             navigate("/login");
           dispatch<any>(
             setToast({
               message: response?.payload?.message,
               type: "success",
               title: "Success",
             })
           );
         } else {
           setLoading(false);
           dispatch<any>(
             setToast({
               message: response.payload.message,
               type: "error",
               title: "Error",
             })
           );
         }
       } catch (error) {
         
       } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="delete-modal-title"
      // sx={{ zIndex: 99 }}
    >
      <ModalWrapper
        sx={{
          width: isMobile ? "90%" : "45%",
          maxWidth: "498px",
          minHeight: "350px",
          maxHeight: "602px",
          margin: "auto",
          overflow: "hidden",


          p: isMobile ? 2 : 3,
        }}
      >
        <CloseButtonWrapper>
          <CloseButton onClick={handleClose}>
            <CrossIcon />
          </CloseButton>
        </CloseButtonWrapper>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            // margin: "20px 0",
          }}
        >
          <LogOutIcon />
        </Box>

        <Content sx={{ textAlign: "center" }}>
          <Typography
            sx={{
              fontSize: "22px",
              fontWeight: 700,
              marginBottom: "12px",
            }}
          >
            Logout
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              textAlign: "center",
              marginBottom: "20px",
              lineHeight: "1.5",
              color: "#6C6F71",
            }}
          >
           Are you sure you want to logout the account?
          </Typography>
        </Content>

        <ButtonWrapper
          sx={{
            display: "flex",
            marginTop: "15px",
            marginBottom: "15px",
            justifyContent: isMobile ? "center" : "space-between",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "10px" : "2px",
          }}
        >
          <CustomButton
            btnTitle="No"
            handleClick={handleClose}
            disabled={loading}
            minwidth={isMobile ? "100%" : "45%"}
            bgColor="#FFF"
            textColor="#2977CC"
            borderColor={loading ? "transparent" : "#2977CC"}
            borderWidth={2.3}
            sx={{ fontSize: "18px" }}
          />

          <CustomButton
            btnTitle={"Yes"}
            loading={loading}
            handleClick={handleSubmit}
            disabled={loading}
            minwidth={isMobile ? "100%" : "45%"}
            borderColor={loading ? "transparent" : "#2977CC"}
            sx={{ fontSize: "18px" }}
          />
        </ButtonWrapper>
      </ModalWrapper>
    </Modal>
  );
}
